import { Box, Button, Typography } from "@mui/material";
import React, { useMemo } from "react";
import NodeEdit from "./NodeEdit";
import { useReactFlow } from "reactflow";
import { messageComponentMap } from "../ChatBotDetail";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
const MessageBuilder = ({ id, data }) => {
  const { setNodes } = useReactFlow();

  console.log(data, id);

  const handleEdit = () => {
    setNodes((nds) =>
      nds.map((item) =>
        item.id === id
          ? { ...item, data: { ...item.data, edit: true } }
          : { ...item, data: { ...item.data, edit: false } }
      )
    );
  };
  const MemoizedComponent = useMemo(() => {
    if (!data?.type) return null;
    const Component = messageComponentMap[data.type];
    return Component ? <Component data={data} preview={true} /> : null;
  }, [data]);
  return (
    <Box>
      <NodeEdit id={id} />
      {MemoizedComponent || (
        <Box m={1}>
          <Typography mb={1} variant="h6">
            Use Edit option to select your type
          </Typography>
          <Box display={"flex"} justifyContent={"center"}>
            <Button
              startIcon={<SpellcheckIcon />}
              onClick={handleEdit}
              variant="outlined"
            >
              Select Message
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MessageBuilder;
